module.exports = __webpack_public_path__ + "media/icons/web-banking-1d33264e.png";